// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

const opts = {
    theme: {
        themes: {
            light: {
                primary: '#c49f79',
                secondary: '#416681',
                accent: '#ff9800',
                info: '#66a5ad',
                error: '#cd5c5c',
                goldColor: '#cda252',
                greyColor: '#BDBDBD',
                lightSeaGreen: '#20b2aa',
                indianRed: '#cd5c5c',
                tableSelectLine: '#c0bcbf',
            },
            dark: {
                primary: '#003b46',
                secondary: '#07575b',
                accent: '#ff9800',
                info: '#66a5ad',
                error: '#F4511E'
            }
        },
    }
}

export default new Vuetify(opts)